import React from "react";
import { createPortal } from "react-dom";

/**
 * Cabecera pegajosa (título + botón X) para formularios largos.
 * Los márgenes negativos compensan el padding del panel para que el fondo
 * opaco cubra todo el ancho al hacer scroll.
 */
export const MODAL_HEADER =
  "sticky -top-4 sm:-top-6 md:-top-8 z-20 -mx-4 sm:-mx-6 md:-mx-8 -mt-4 sm:-mt-6 md:-mt-8 " +
  "px-4 sm:px-6 md:px-8 pt-4 sm:pt-6 md:pt-8 pb-3 " +
  "bg-[var(--ag7-surface)] border-b border-[var(--ag7-border)] " +
  "flex items-center justify-between gap-3";

/** Barra de acciones pegajosa (Cancelar / Guardar) siempre visible en móvil. */
export const MODAL_ACTIONS =
  "sticky -bottom-4 sm:-bottom-6 md:-bottom-8 z-20 -mx-4 sm:-mx-6 md:-mx-8 -mb-4 sm:-mb-6 md:-mb-8 " +
  "px-4 sm:px-6 md:px-8 pt-3 " +
  "pb-[max(1rem,env(safe-area-inset-bottom))] sm:pb-[max(1.5rem,env(safe-area-inset-bottom))] " +
  "bg-[var(--ag7-surface)] border-t border-[var(--ag7-border)] flex gap-3 " +
  // tapa la franja de padding inferior del panel para que nada se cuele por detrás
  "after:content-[''] after:absolute after:inset-x-0 after:top-full after:h-8 " +
  "after:bg-[var(--ag7-surface)]";

export function Modal({ children, onClose, size = "md", testId }) {
  const sizeCls =
    size === "sm" ? "max-w-md"
    : size === "lg" ? "max-w-lg"
    : size === "xl" ? "max-w-3xl"
    : "max-w-xl";
  // Portal a document.body: un ancestro con backdrop-filter/transform/filter
  // (glass cards) convierte a ese ancestro en el "containing block" de los
  // descendientes position:fixed — el modal quedaría recortado por el
  // overflow-hidden de esa tarjeta en vez de cubrir la pantalla completa.
  return createPortal(
    <div
      className="fixed inset-0 z-50 flex items-center justify-center p-2 sm:p-4 bg-black/80 backdrop-blur-md h-[100dvh] overflow-hidden"
      data-testid={testId}
      onClick={onClose}
    >
      <div data-testid="modal-div-1"
        className={`bg-[var(--ag7-glass)] backdrop-blur-xl border border-[var(--ag7-border)] rounded-2xl sm:rounded-3xl w-full ${sizeCls} p-4 sm:p-6 md:p-8 shadow-[0_24px_60px_-18px_rgba(0,0,0,0.9),var(--ag7-glow-purple)] space-y-4 sm:space-y-5 max-h-[calc(100dvh-1rem)] sm:max-h-[calc(100dvh-2rem)] overflow-y-auto overscroll-contain`}
        onClick={(e) => e.stopPropagation()}
      >
        {children}
      </div>
    </div>,
    document.body
  );
}
